import {AfterViewInit, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {faMagic, faTimes} from '@fortawesome/free-solid-svg-icons';
import {GoogleMap} from '@angular/google-maps';
import {VideoPlayerComponent} from '../video-player/video-player.component';
import {ActivatedRoute, Router} from '@angular/router';
import {GamePromptService} from '../game-prompt.service';
import {StateManagerService} from '../state-manager.service';
import {LocationServiceService} from '../location-service.service';
import {animate, group, keyframes, query, sequence, state, style, transition, trigger} from '@angular/animations';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

const segmentTime = 1000;

@Component({
  selector: 'app-end',
  templateUrl: './end.component.html',
  styleUrls: ['./end.component.css'],
  animations: [
    trigger('fadeOutTrigger', [
      // ...
      state('shown', style({
        opacity: 1
      })),
      state('hidden', style({
        opacity: 0,
        'z-index': -1
      })),
      transition('* => hidden', [
        animate('1s')
      ])
    ]),
    trigger('slowFadeOutTrigger', [
      // ...
      state('shown', style({
        opacity: 1
      })),
      state('hidden', style({
        opacity: 0,
        'z-index': -1
      })),
      transition('* => hidden', [
        animate('3s')
      ]),
      transition('* => shown', [
        animate('3s')
      ])
    ]),
    trigger('shakeit', [
      state('shakestart', style({
        transform: 'scale(1)',
      })),
      state('shakeend', style({
        transform: 'scale(1)',
      })),
      transition('shakestart => shakeend', animate('1000ms ease-in', keyframes([
        style({transform: 'translate3d(-1px, 0, 0)', offset: 0.1}),
        style({transform: 'translate3d(2px, 0, 0)', offset: 0.2}),
        style({transform: 'translate3d(-4px, 0, 0)', offset: 0.3}),
        style({transform: 'translate3d(4px, 0, 0)', offset: 0.4}),
        style({transform: 'translate3d(-4px, 0, 0)', offset: 0.5}),
        style({transform: 'translate3d(4px, 0, 0)', offset: 0.6}),
        style({transform: 'translate3d(-4px, 0, 0)', offset: 0.7}),
        style({transform: 'translate3d(2px, 0, 0)', offset: 0.8}),
        style({transform: 'translate3d(-1px, 0, 0)', offset: 0.9}),
      ]))),
    ]),
    trigger('letterATrigger', [
      // ...
      state('end', style({
        transform: 'translate(calc(400% + 80px), 0)'
      })),
      transition('* => end', [
       sequence([
         animate(segmentTime /2 + 'ms', style({
           transform: 'translate(-50%, 0%)'
         })),
         animate(segmentTime / 2 + 'ms', style({
           transform: 'translate(-130%, -150%)'
         })),
         animate(segmentTime + 'ms', style({
           transform: 'translate(-200%, -300%)'
         })),
         // first quad.
         animate(segmentTime + 'ms', style({
           transform: 'translate(200%, -350%)'
         })),
         animate(segmentTime + 'ms', style({
           transform: 'translate(600%, -300%)'
         })),
         animate(segmentTime + 'ms', style({
           transform: 'translate(calc(400% + 80px), 0)'
         }))
       ])
      ])
    ]),
    trigger('letterLTrigger', [
      // ...
      state('end', style({
        transform: 'translate(calc(-100% + -20px), 0)'
      })),
      transition('* => end', [
        sequence([
        animate(segmentTime + 'ms', style({
          transform: 'translate(-50%, -200%)'
        })),
        // first quad.
        animate(segmentTime + 'ms', style({
          transform: 'translate(-100%, -170%)'
        })),
        animate(segmentTime + 'ms', style({
          transform: 'translate(-170%, -100%)'
        })),

          animate(segmentTime + 'ms', style({
            transform: 'translate(calc(-200% + 20px), 0)'
          }))
          ])
      ])
    ]),
    trigger('letterOTrigger', [
      // ...
      state('end', style({})),
      transition('* => end', [
        sequence([
          animate(segmentTime + 'ms', style({
            transform: 'translate(-50%, -100%)rotate(180deg)'
          })),
          // first quad.
          animate(segmentTime + 'ms', style({
            transform: 'translate(-100%, -150%)rotate(270deg)'
          })),
          animate(segmentTime + 'ms', style({
            transform: 'translate(0, 0)rotate(360deg)'
          }))
        ])
      ])
    ]),
    trigger('letterNTrigger', [
      // ...
      state('end', style({})),
      transition('* => end', [
        sequence([
          animate(segmentTime + 'ms', style({
            transform: 'translate(-50%, -100%)'
          })),
          // first quad.
          animate(segmentTime + 'ms', style({
            transform: 'translate(-100%, -150%)'
          })),
          animate(segmentTime + 'ms', style({
            transform: 'translate(0, 0)'
          }))
        ])
      ])
    ]),
    trigger('letterETrigger', [
      // ...
      state('end', style({
        transform: 'translate(calc(-300% + -60px), 0)'
      })),
      transition('* => end', [
        sequence([
          animate(segmentTime + 'ms', style({
            transform: 'translate(200%, -100%)rotate(90deg)'
          })),
          // first quad.
          animate(segmentTime + 'ms', style({
            transform: 'translate(-100%, -250%)rotate(180deg)'
          })),
          animate(segmentTime + 'ms', style({
            transform: 'translate(-200%, -175%)rotate(270deg)'
          })),
          animate(segmentTime + 'ms', style({
            transform: 'translate(calc(-300% + -60px), 0) rotate(360deg)'
          }))
        ])
      ])
    ]),

  ]
})
export class EndComponent implements OnInit, AfterViewInit {

  passwordPopupState = 'shown';
  landscapeSectionState = 'hidden';
  sectionPopupState = 'hidden';
  lettersContainerState = 'hidden';
  states = {
    letterAState: 'start',
    letterLState: 'start',
    letterOState: 'start',
    letterNState: 'start',
    letterEState: 'start'
  };

  magic = faMagic;
  close = faTimes;
  wasPlaying = false;


  @ViewChild('playerComponent') player: VideoPlayerComponent;


  letters = ['E',
    'L',
    'A',
    'O',
    'N'];
  // letters = ['A', 'L', 'O', 'N', 'E'];


  constructor(private route: ActivatedRoute, public promptService: GamePromptService, private stateManager: StateManagerService, private router: Router, private locationService: LocationServiceService) {
    this.states['passwordUnlockText'] = 'shakestart';
  }

  shakeMe(stateVar: string) {
    this.states[stateVar] = (this.states[stateVar] === 'shakestart' ? 'shakeend' : 'shakestart');
  }

  shakeEnd(stateVar: string, event) {
    this.states[stateVar] = 'shakeend';
  }

  ngOnInit(): void {
    this.passwordPopupState = 'shown';

    setInterval(this.checkVideoTimestamp.bind(this), 1000);
  }

  ngAfterViewInit(): void {
    this.checkWindowSize();
  }

  checkVideoTimestamp(): void {
    const currTime = this.player?.video.nativeElement.currentTime;

    if(currTime > 72) {
      this.lettersContainerState = 'shown';
    }

    if(currTime > 90) {
      this.lettersContainerState = 'hidden';
    }


    if (currTime > 82) { // 82 1.22 timestamp to move the letters.
      this.states.letterAState = 'end';
      this.states.letterLState = 'end';
      this.states.letterOState = 'end';
      this.states.letterNState = 'end';
      this.states.letterEState = 'end';
    }
  }

  checkWindowSize(): void {
    if (window.innerHeight > window.innerWidth) {
      console.log('height is bigger than width so stop the video.');
      // Tell the user to rotate to landscape
      this.landscapeSectionState = 'shown';
      if (this.player?.playing()) {
        console.log('Player is playing.');
        this.wasPlaying = true;
        console.log('Pausing.');
        this.player.pause();
      }
    } else {
      this.landscapeSectionState = 'hidden';
      if (this.wasPlaying) {
        this.player.resume();
      }
    }
  }


  drop(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.letters, event.previousIndex, event.currentIndex);
    const word = this.letters.join('');
    if (word === 'ALONE') {
      this.player.playVideo();
      this.passwordPopupState = 'hidden';
    }
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    console.log(event);
    this.checkWindowSize();
  }

  startedPlaying():void {
    console.log('playing');
    if(this.passwordPopupState === 'shown') {
      this.player.pause();
    }

    // Temp

    // this.player.pause();
    // this.videoEnded();

  }
  videoEnded(): void {
    // The video stopped playing and fullscreen closed.
    console.log('video ended');
    this.sectionPopupState = 'shown';

    // Check if we need to award a letter.
  }
}
